module.exports = __webpack_public_path__ + "static/media/nft-img-demo.7e617e17.jpg";